import {Button, Fade, Link, Menu, MenuItem, styled, Theme, Typography} from '@mui/material';
import {AuthorizationsIcon} from '@ozark/common/icons/Authorizations';
import {DepositsIcon} from '@ozark/common/icons/Deposits';
import {DisputesIcon} from '@ozark/common/icons/Disputes';
import {StatementsIcon} from '@ozark/common/icons/Statements';
import {TransactionsIcon} from '@ozark/common/icons/Transactions';
import {TransactionsPendingIcon} from '@ozark/common/icons/TransactionsPending';
import * as ROUTES from '@ozark/crm/src/constants/routes';
import {Fragment, useState} from 'react';

export type MidReportingOptionsProps = {
  isButtonOutlined?: boolean;
  selectedMid: string;
};

export const IconWrapper = styled('span')(({theme}: {theme: Theme}) => ({
  marginRight: theme.spacing(1.5),
}));

export const MidReportingOptions = ({
  selectedMid,
  isButtonOutlined = false,
}: MidReportingOptionsProps) => {
  const [midReportingMenuEl, setMidReportingMenuEl] = useState<null | HTMLElement>(null);

  const handleOpenMidReportingMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
    setMidReportingMenuEl(event.currentTarget);
  };

  const midQueryString = new URLSearchParams({mid: selectedMid}).toString();

  return (
    <Fragment>
      <Button
        sx={{ml: 1}}
        onClick={handleOpenMidReportingMenu}
        variant={isButtonOutlined ? 'outlined' : 'text'}
      >
        MID Reporting
      </Button>
      <Menu
        id="mid-reporting-menu"
        anchorEl={midReportingMenuEl}
        onClose={() => setMidReportingMenuEl(null)}
        keepMounted
        open={Boolean(midReportingMenuEl)}
        anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
        transformOrigin={{horizontal: 'right', vertical: 'top'}}
        TransitionComponent={Fade}
      >
        <MenuItem>
          <Link
            href={`${ROUTES.AUTHORIZATIONS}?${midQueryString}`}
            sx={{display: 'flex'}}
            target="_blank"
          >
            <IconWrapper>
              <AuthorizationsIcon />
            </IconWrapper>
            <Typography>Authorizations</Typography>
          </Link>
        </MenuItem>

        <MenuItem>
          <Link
            href={`${ROUTES.TRANSACTIONS}?${midQueryString}`}
            sx={{display: 'flex'}}
            target="_blank"
          >
            <IconWrapper>
              <TransactionsIcon />
            </IconWrapper>
            <Typography>Transactions</Typography>
          </Link>
        </MenuItem>

        <MenuItem>
          <Link href={`${ROUTES.BATCHES}?${midQueryString}`} sx={{display: 'flex'}} target="_blank">
            <IconWrapper>
              <TransactionsPendingIcon />
            </IconWrapper>
            <Typography>Batches</Typography>
          </Link>
        </MenuItem>

        <MenuItem>
          <Link
            href={`${ROUTES.DEPOSITS}?${midQueryString}`}
            sx={{display: 'flex'}}
            target="_blank"
          >
            <IconWrapper>
              <DepositsIcon />
            </IconWrapper>
            <Typography>Deposits</Typography>
          </Link>
        </MenuItem>

        <MenuItem>
          <Link
            href={`${ROUTES.CHARGEBACKS_SUMMARY}?${midQueryString}`}
            sx={{display: 'flex'}}
            target="_blank"
          >
            <IconWrapper>
              <DisputesIcon />
            </IconWrapper>
            <Typography>Disputes</Typography>
          </Link>
        </MenuItem>

        <MenuItem>
          <Link
            href={`${ROUTES.STATEMENTS}?${midQueryString}`}
            sx={{display: 'flex'}}
            target="_blank"
          >
            <IconWrapper>
              <StatementsIcon />
            </IconWrapper>
            <Typography>Statements</Typography>
          </Link>
        </MenuItem>
      </Menu>
    </Fragment>
  );
};
